// src/components/HeroVideoBanner.jsx
import React from "react";
import { Link } from "react-router-dom";

function HeroVideoBanner() {
  return (
    <section className="gs-hero">
      {/* Vidéo de fond */}
      <video
        className="gs-hero-video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="/videos/wmp-homepage-bw1-compressed.mov"
          type="video/mp4"
        />
        Votre navigateur ne supporte pas la vidéo HTML5.
      </video>

      {/* Overlay sombre + dégradé */}
      <div className="gs-hero-overlay" />

      {/* Contenu texte */}
      <div className="gs-hero-inner">
        <div className="gs-hero-badge">
          Nouveau · Essai gratuit 14 jours pour les vendeurs
        </div>

        <h1 className="gs-hero-title">
          Vendez plus, <span>sans complexité.</span>
        </h1>

        <p className="gs-hero-text">
          GoShop connecte votre boutique à des milliers de clients
          grâce à un catalogue en ligne, le paiement Mobile Money
          et une logistique adaptée à la réalité locale.
        </p>

        <div className="gs-hero-meta">
          <span>✔ Paiement Mobile Money & à la livraison</span>
          <span>✔ Vitrine en ligne pour votre boutique</span>
          <span>✔ Essai gratuit 14 jours, sans engagement</span>
        </div>

        <div className="gs-hero-cta">
          <Link
            to="/inscription-vendeur"
            className="gs-hero-btn gs-hero-btn-primary"
          >
            Devenir vendeur GoShop
          </Link>

          <a
            href="#abonnements"
            className="gs-hero-btn gs-hero-btn-secondary"
          >
            Voir les offres vendeurs
          </a>
        </div>
      </div>
    </section>
  );
}

export default HeroVideoBanner;
